import React from 'react';
import List from '@material-ui/core/List';
import { EmptyProviders } from './EmptyProviders.esm.js';
import { DefaultProviderSettings } from './DefaultProviderSettings.esm.js';
import { useApi, configApiRef } from '@backstage/core-plugin-api';
import { InfoCard } from '@backstage/core-components';

const UserSettingsAuthProviders = (props) => {
  const { providerSettings } = props;
  const configApi = useApi(configApiRef);
  const providersConfig = configApi.getOptionalConfig("auth.providers");
  const configuredProviders = providersConfig?.keys() || [];
  const providers = providerSettings ?? /* @__PURE__ */ React.createElement(DefaultProviderSettings, { configuredProviders });
  if (!providerSettings && !configuredProviders?.length) {
    return /* @__PURE__ */ React.createElement(EmptyProviders, null);
  }
  return /* @__PURE__ */ React.createElement(InfoCard, { title: "Available Providers" }, /* @__PURE__ */ React.createElement(List, { dense: true }, providers));
};

export { UserSettingsAuthProviders };
//# sourceMappingURL=UserSettingsAuthProviders.esm.js.map
